import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { find, isEmpty } from 'lodash';
import { Image, RKPayRibbon, Tooltip } from '@components/common';
import { utils, constants } from '../../../utils';

class Officer extends PureComponent {
	render() {
		const {
			url,
			firstName,
			lastName,
			createDate,
			timeZone,
			officerRank,
			jurisdiction,
			jobsWorked,
			upcomingJobs,
			totalHours,
			clockIn,
			clockOut,
			officerStatusType,
			isRKPay,
			isPermanent,
			isExternal,
			isActiveOrCompletedJob,
		} = this.props;
		const officerStatus = find(constants.OFFICER_STATUSES, ['type', officerStatusType]) || constants.OFFICER_STATUSES.none;

		return (
			<div className="applicant-officer">
				<div className="applicant-officer__content-wrapper">
					<div className={classNames('applicant-officer__image-container', { tight : isActiveOrCompletedJob })}>
						<Image
							src={url}
							fallbackSrc="avatar"
						/>
						<If condition={isPermanent && !isEmpty(isPermanent)}>
							<Tooltip content="This officer is assigned to multiple occurrences of this job">
								<i className="rkf rkf-refresh permanent-post-icon" />
							</Tooltip>
						</If>
					</div>
					<div>
						<div className="applicant-officer__content">
							<h4>
								{ firstName }
								{' '}
								{ lastName }
							</h4>
							<If condition={createDate}>
								<span className="margin-left-11 margin-top-4">
									{ utils.parseUTCDateToTimeZone(createDate, timeZone).fromNow() }
								</span>
							</If>
						</div>
						<Choose>
							<When condition={!isExternal}>
								<div className={classNames('applicant-officer__content', { tight : isActiveOrCompletedJob })}>
									<p>{ officerRank }</p>
									<p>{ jurisdiction }</p>
								</div>
								<div className="applicant-officer__content tags">
									<If condition={!isActiveOrCompletedJob}>
										<If condition={jobsWorked}>
											<div className="tag">
												{ utils.abbreviateNumber(jobsWorked) }
												{' '}
												Jobs Worked
											</div>
										</If>
										<If condition={upcomingJobs}>
											<div className="tag">
												{ utils.abbreviateNumber(upcomingJobs) }
												{' '}
												Upcoming Jobs
											</div>
										</If>
										<If condition={officerStatusType === constants.OFFICER_STATUSES.seekingReplacement.type}>
											<div className={classNames('tag', `tag-${officerStatus.color}`)}>
												{ officerStatus.description }
											</div>
										</If>
									</If>
								</div>
							</When>
							<Otherwise>
								<div className="applicant-officer__content">
									<p>Non-RollKall Officer</p>
								</div>
							</Otherwise>
						</Choose>
					</div>
				</div>
				<If condition={isActiveOrCompletedJob && !isExternal}>
					<div className="applicant-officer__officer-status">
						<div className="flex">
							<div>
								<p>{ clockIn ? utils.parseUTCDateToTimeZone(clockIn, timeZone).format('hh:mm A') : '--' }</p>
								<span>Clock-In</span>
							</div>
							<div>
								<p>{ clockOut ? utils.parseUTCDateToTimeZone(clockOut, timeZone).format('hh:mm A') : '--' }</p>
								<span>Clock-Out</span>
							</div>
						</div>
						<div className="tag margin-0">
							{ utils.abbreviateNumber(totalHours) }
							{' '}
							Total Hours
						</div>
					</div>
					<div className="applicant-officer__content">
						<div className={classNames('tag', `tag-${officerStatus.color}`)}>
							{ officerStatus.description }
						</div>
					</div>
				</If>
				<If condition={isRKPay}>
					<RKPayRibbon />
				</If>
			</div>
		);
	}
}

Officer.propTypes = {
	url                    : PropTypes.string,
	firstName              : PropTypes.string.isRequired,
	lastName               : PropTypes.string.isRequired,
	createDate             : PropTypes.string,
	timeZone               : PropTypes.string.isRequired,
	officerRank            : PropTypes.string,
	jurisdiction           : PropTypes.string,
	jobsWorked             : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	upcomingJobs           : PropTypes.number,
	totalHours             : PropTypes.number.isRequired,
	clockIn                : PropTypes.string,
	clockOut               : PropTypes.string,
	officerStatusType      : PropTypes.number,
	isRKPay                : PropTypes.bool.isRequired,
	isPermanent            : PropTypes.bool,
	isExternal             : PropTypes.bool,
	isActiveOrCompletedJob : PropTypes.bool,
};

Officer.defaultProps = {
	url                    : '',
	createDate             : undefined,
	officerRank            : '',
	jurisdiction           : '',
	jobsWorked             : undefined,
	upcomingJobs           : undefined,
	clockIn                : undefined,
	clockOut               : undefined,
	officerStatusType      : undefined,
	isPermanent            : false,
	isExternal             : false,
	isActiveOrCompletedJob : false,
};

export default Officer;
